module.exports = __webpack_public_path__ + "media/images/document-0502356542402c9d3673154352109b0c.png";